import { getContextFromUrl } from 'config/Config';

export const properties = {
    ID_BOTON: 'botonAyuda',
    ARIA_LABEL_BOTON : 'ayuda',
    ATRIBUTO_ARIA_EXPANDED: 'aria-expanded',
    SRC_IMG: '/popUpHerramientas/toolsSolid.svg',
    ALT_IMG: 'Herramientas y enlaces'
}

export const pages = {
    HOME: '',
}

export const textoTituloPopUp = {
    cabecera: {
        titulo: 'Herramientas y enlaces',
        parrafo: 'En esta sección puede encontrar diferentes enlaces o herramientas de utilidad',
    },
    button: 'Volver',
}

export const listadoPreguntas = [

    {
        id: '1001',
        descripcion: 'Herramientas',
        mensajes: [
            {
                idDescripcion: '001',
                descripcionMensaje: 'Descarga',
                idMensaje: '001',
                contenidoMensaje: '<a href="https://ws024.juntadeandalucia.es/ae/adminelec/areatecnica/autofirma" target="_blank">Autofirma</a>',
            },
            {
                idDescripcion: '002',
                descripcionMensaje: 'En linea',
                idMensaje: '002',
                contenidoMensaje: '<a href="https://ws024.juntadeandalucia.es/afirma-validator//validator.action?clientVersion=applet_3.3.1_12&signatureFormat=cades&callbackUrl=http://www.juntadeandalucia.es/economiainnovacionyciencia/oficinavirtual" target="_blank">Validación de Firma Electrónica</a></br><a href="https://ws050.juntadeandalucia.es/verificarFirma/" target="_blank">Validación de Firma Electrónica (HCV)</a></br><a href="https://www.juntadeandalucia.es/empleoformacionytrabajoautonomo/verifirma2/" target="_blank">Validación de Firma Electrónica (Verifirma)</a></br><a href="#MatrizCompatibilidad" target="_blank">Matriz de Compatibilidad</a>',
            }
        ]
    },
    {
        id: '1002',
        descripcion: 'Enlaces',
        mensajes: [
            {
                idDescripcion: '003',
                descripcionMensaje: 'Certificados Electrónicos',
                idMensaje: '003',
                contenidoMensaje: '<a href="https://www.abogacia.es/site/aca/que-es-aca-y-que-ventajas-te-ofrece/" target="_blank">ACA</a></br><a href="http://www.ancert.com/liferay/web/ancert/inicio" target="_blank">ANCERT</a></br><a href="https://www.camerfirma.com/" target="_blank">CAMERFIRMA</a></br><a href="http://www.cert.fnmt.es/" target="_blank">CERES FNMT</a></br><a href="https://www.dnielectronico.es/PortalDNIe/" target="_blank">DNI Electrónico</a></br><a href="https://clave.gob.es/clave_Home/clave.html" target="_blank">Cl@ve</a></br>',
            }
        ]
    },
    {
        id: '1003',
        descripcion: 'Administración Electrónica',
        mensajes: [
            {
                idDescripcion: '004',
                descripcionMensaje: 'Enlaces',
                idMensaje: '004',
                contenidoMensaje: '<a href="https://www.juntadeandalucia.es/servicios/tramites/presentacion-documentos/calendario-dias-inhabiles.html" target="_blank">Calendario de días inhábiles</a></br><a href="https://www.juntadeandalucia.es/servicios/carpeta-ciudadana.html" target="_blank">Carpeta ciudadana</a></br><a href="https://www.juntadeandalucia.es/servicios/procedimientos.html" target="_blank">Catálogo de Procedimientos y Servicios</a></br><a href="https://www.juntadeandalucia.es/servicios/tramites/presentacion-documentos/dir3.html" target="_blank">Códigos de identificación de órganos y unidades administrativas</a></br><a href="https://www.juntadeandalucia.es/servicios/tramites/presentacion-documentos/lsr.html" target="_blank">Libro de Sugerencias y Reclamaciones</a></br><a href="https://www.juntadeandalucia.es/servicios/tramites/servicios-digitales/notificaciones-electronicas.html" target="_blank">Notificaciones electrónicas</a></br><a href="https://www.juntadeandalucia.es/servicios/tramites/presentacion-documentos/registro-electronico.html" target="_blank">Registro Electrónico Único</a></br>',
            },
            {
                idDescripcion: '005',
                descripcionMensaje: 'Sistemas de identificación y firma electrónica',
                idMensaje: '005',
                contenidoMensaje: '<p>Certificado Digital, <a href="https://clave.gob.es/clave_Home/clave.html" target="_blank">Cl@ve</a>, Identificación con localizador</p>',
            },
            {
                idDescripcion: '006',
                descripcionMensaje: 'Relación de los sellos electrónicos y sistemas de firma',
                idMensaje: '006',
                contenidoMensaje: '<a href="#SelloElectronicoSistemasFirma" target="_blank">Relación de los sellos electrónicos y sistemas de firma</a>',
            },
        ]
    }
]